/**
 *
 * Address Service Selectors
 *
 */

import { createSelector } from 'reselect/lib';
import { NAMESPACE } from './constants';

const selectService = (state) => (state ? state[NAMESPACE] : {});

const selectStatus = createSelector(selectService, (service) => service.status);

const selectResults = createSelector(selectService, (service) => service.result);

const selectError = createSelector(selectService, (service) => service.error);

export { selectStatus, selectResults, selectError };



// WEBPACK FOOTER //
// ./src/services/addressPreview/selectors.js